export interface Environment {
  BASE_API: string;
  USER_API: string;
  COMPANY_ID?: number;
  COMPANY_NAME?: string;
  APP_ID?: number;
  APP_NAME?: string;
  SECRET_KEY?: string;
  PRODUCTION?: boolean;
  MAGIC_BELL_API?: string;
  MAGIC_BELL_KEY?: string;
  MAGIC_BELL_SECRET_KEY?: string;
  awsCredentials?: {
    accessKeyId: string;
    secretAccessKey: string;
    region: string;
  };
  DEFAULT_THEME?: "dark" | "white";
  AWS_ACL?: string;
  AWS_BUCKET_NAME?: string;
  AWS_ROOT_URL?: string;
  GIT_BRANCH?: string;
  IS_LOCAL_STORAGE?: boolean;
}
